const base = 'bbraun-ui-login-dialog';

export const LOGIN_DIALOG_DATA_TEST = {
  loginButton: {
    selector: `${base}:login`,
  },
  username: { selector: `${base}:username` },
  password: { selector: `${base}:password` },
};
